import { FC } from "react";

import { PageHeading, Sections, TeamHeading } from "@/components/Layout/Parts";
import PerformanceIndexes from "./components/PerformanceIndexes";

const Performance: FC = () => {
  return (
    <>
      <TeamHeading />
      <PageHeading>Performance</PageHeading>
      <Sections $gapY={56}>
        <PerformanceIndexes />
      </Sections>
    </>
  );
};

export default Performance;
